import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const router = new Router({
	mode: "hash",
	routes: [{
			path: '/',
			name: 'home',
			component: () =>
				import('@/view/main/home.vue'),
			redirect: {
				name: 'index'
			},

			children: [{
					// 首页
					path: '/index',
					name: 'index',
					component: () =>
						import("@/view/main/index.vue"),
					meta: {
						title: "主页",
						url: '',
						index: "1",
						name: "主页"
					}
				},

				{
					// 工作状态
					path: '/work',
					name: 'homeWorkStatus',
					component: () =>
						import("@/components/home/workStatus.vue"),
					meta: {
						title: "工作状态",
						url: '',
						index: "1"
					}
				},
				{
					// 通讯录
					path: '/contacts',
					name: 'homeContacts',
					component: () =>
						import("@/components/home/contact.vue"),
					meta: {
						title: "通讯录",
						url: '',
						index: "1"
					}
				},
				{
					// 写日志
					path: '/log',
					name: 'homeLog',
					component: () =>
						import("@/components/home/log.vue"),
					meta: {
						title: "写日志",
						url: '',
						index: "1"
					}
				},
				{
					// 通知消息
					path: '/noticeMsg',
					name: 'noticeMsg',
					component: () => import("@/components/home/noticeMsg.vue"),
					meta: {
						title: "通知消息",
						url: '',
					}
				},


				/******** 综合管理模块 *********/
				// {
				// 	path: '/basicLaw',
				// 	name: 'basicLaw',
				// 	component: basicLaw => require(['@/components/overall/basicLaw/detail'], basicLaw),
				// 	meta: [{
				// 		url: '',
				// 		name: '综合管理'
				// 	}, {
				// 		url: '',
				// 		name: '建科基本法'
				// 	}]
				// },
				{
					path: '/basicLaw/edit',
					name: 'basicLawEdit',
					component: basicLawEdit => require(['@/components/overall/basicLaw/edit'],
						basicLawEdit),
					meta: [{
						url: '',
						name: '综合管理'
					}, {
						url: '',
						name: '编辑建科基本法'
					}]
				},

				{
					path: '/systemGuide/list',
					name: 'systemGuide',
					component: systemGuide => require(['@/components/overall/systemGuide/list'],
						systemGuide),
					meta: {
						breadList: [{
							url: '',
							name: '综合管理'
						}, {
							url: 'systemGuide',
							name: '制度指南'
						}]
					}
				},
				{
					path: '/systemGuide/detail',
					name: 'systemGuideDetail',
					component: systemGuideDetail => require(['@/components/overall/systemGuide/detail'],
						systemGuideDetail),
					meta: [{
						url: '',
						name: '综合管理'
					}, {
						url: 'systemGuideDetail',
						name: '制度指南详情'
					}]
				},
				{
					path: '/systemGuide/edit',
					name: 'systemGuideEdit',
					component: systemGuideEdit => require(['@/components/overall/systemGuide/edit'],
						systemGuideEdit),
					meta: [{
						url: '',
						name: '综合管理'
					}, {
						url: 'systemGuideEdit',
						name: '编辑制度指南'
					}]
				},
				{
					path: '/overall/commonQA/list',
					name: 'commonQAList',
					component: commonQAList => require(['@/components/overall/commonQA/list'],
						commonQAList),
					meta: {
						breadList: [{
							url: '',
							name: '综合管理'
						}, {
							url: 'commonQAList',
							name: '常见问答'
						}]
					}
				},
				
				// {
				// 	path: '/overall/commonQA/edit',
				// 	name: 'commonQAEdit',
				// 	component: commonQAEdit => require(['@/components/overall/commonQA/edit'], commonQAEdit),
				// 	meta: {breadList:[{ url: '', name: '综合管理' }, { url: 'commonQAEdit', name: '编辑常见问答' }]}
				// },
				// {
				// 	path: '/overall/commonQA/detail',
				// 	name: 'commonQADetail',
				// 	component: commonQADetail => require(['@/components/overall/commonQA/detail'], commonQADetail),
				// 	meta: {breadList:[{ url: '', name: '综合管理' }, { url: 'commonQADetail', name: '常见问答详情' }]}
				// },

				// 计划总结
				{
					path: '/planSummary/list',
					name: 'planSummaryList',
					component: planSummaryList => require(['@/components/overall/planSummary/list'],
						planSummaryList),
					meta: {
						breadList: [{
							url: '',
							name: '综合管理'
						}, {
							url: 'planSummaryList',
							name: '计划总结'
						}]
					}
				},
				{
					path: '/planSummary/detail',
					name: 'planSummaryDetail',
					component: planSummaryDetail => require(['@/components/overall/planSummary/detail'],
						planSummaryDetail),
					meta: {
						breadList: [{
							url: '',
							name: '综合管理'
						}, {
							url: 'planSummaryDetail',
							name: '计划总结详情'
						}]
					}
				},
				{
					path: '/planSummary/edit',
					name: 'planSummaryEdit',
					component: planSummaryEdit => require(['@/components/overall/planSummary/edit'],
						planSummaryEdit),
					meta: {
						breadList: [{
							url: '',
							name: '综合管理'
						}, {
							url: 'planSummaryEdit',
							name: '编辑计划总结'
						}]
					}
				},
				// {
				// 	path: '/overall/workRecord/calendar',
				// 	name: 'workCalendar',
				// 	component: workCalendar => require(['@/components/overall/workrecord/calendar'], workCalendar),
				// 	meta: {
				// 		breadList: [{
				// 			url: '',
				// 			name: '综合管理'
				// 		}, {
				// 			url: 'workCalendar',
				// 			name: '工作日历'
				// 		}]
				// 	}
				// },
				{
					path: '/notice/list',
					name: 'noticeList',
					component: noticeList => require(['@/components/overall/notice/list'], noticeList),
					meta: {
						breadList: [{
							url: '',
							name: '综合管理'
						}, {
							url: 'noticeList',
							name: '通知公告'
						}]
					}
				},
				{
					path: '/notice/add',
					name: 'noticeAdd',
					component: noticeAdd => require(['@/components/overall/notice/add'], noticeAdd),
					meta: {
						breadList: [{
							url: '',
							name: '综合管理'
						}, {
							url: 'noticeAdd',
							name: '添加通知公告'
						}]
					}
				},
				{
					path: '/notice/detail',
					name: 'noticeDetail',
					component: noticeDetail => require(['@/components/overall/notice/detail'],
						noticeDetail),
					meta: {
						breadList: [{
							url: '',
							name: '综合管理'
						}, {
							url: 'noticeDetail',
							name: '通知公告详情'
						}]
					}
				},


				// {
				// 	path: '/innerForum/detail',
				// 	name: 'innerForumDetail',
				// 	component: innerForumDetail => require(['@/components/overall/innerForum/detail'], innerForumDetail),
				// 	meta: [{
				// 		url: '',
				// 		name: '综合管理'
				// 	}, {
				// 		url: '',
				// 		name: '内部论坛详情'
				// 	}]
				// },
				{
					path: '/innerForum/edit',
					name: 'innerForumEdit',
					component: innerForumEdit => require(['@/components/overall/innerForum/edit'],
						innerForumEdit),
					meta: [{
						url: '',
						name: '综合管理'
					}, {
						url: '',
						name: '编辑内部论坛内容'
					}]
				},


				/******************* 内部资料 *******************/
				{
					path: '/innerData/list',
					name: 'innerDataList',
					component: innerDataList => require(['@/components/overall/innerData/list'],
						innerDataList),
					meta: {
						breadList: [{
							url: '',
							name: '综合管理'
						}, {
							url: 'innerDataList',
							name: '内部资料'
						}]
					}
				},
				{
					path: '/innerData/dataList',
					name: 'dataList',
					component: dataList => require(['@/components/overall/innerData/dataList'],
						dataList),
					meta: {
						breadList: [{
							url: '',
							name: '综合管理'
						}, {
							url: 'dataList',
							name: '内部资料'
						}]
					}
				},
				/******************* 内部论坛 *******************/
				{
					path: '/innerForum/list',
					name: 'innerForumList',
					component: innerForumList => require(['@/components/overall/innerForum/list'],
						innerForumList),
					meta: {
						breadList: [{
							url: '',
							name: '综合管理'
						}, {
							url: '',
							name: '内部论坛'
						}]
					}
				},

				{
					path: '/innerData/detail',
					name: 'innerDataDetail',
					component: innerDataDetail => require(['@/components/overall/innerData/detail'],
						innerDataDetail),
					meta: {
						breadList: [{
							url: '',
							name: '综合管理'
						}, {
							url: 'innerDataDetail',
							name: '内部资料详情'
						}]
					}
				},

				{
					path: '/innerData/edit',
					name: 'innerDataEdit',
					component: innerDataEdit => require(['@/components/overall/innerData/edit'],
						innerDataEdit),
					meta: {
						breadList: [{
							url: '',
							name: '综合管理'
						}, {
							url: '',
							name: '编辑内部资料'
						}]
					}
				},

				/******************* 放假调休 *******************/
				{
					path: '/workRest',
					name: 'workRest',
					component: workRest => require(['@/components/overall/workRest/detail'], workRest),
					meta: [{
						url: '',
						name: '综合管理'
					}, {
						url: 'workRest',
					}]
				},


				/******************* 流程审批 *******************/
				{
					path: '/overall/workflow/list',
					name: 'workflowList',
					component: workflowList => require(['@/components/overall/workflow/list'],
						workflowList),
					meta: {
						breadList: [{
							url: '',
							name: '综合管理'
						}, {
							url: 'workflowList',
							name: '流程审批'
						}]
					}
				},
				{
					path: '/overall/workflow/flowList',
					name: 'flowList',
					component: flowList => require(['@/components/overall/workflow/flowList'],
						flowList),
					meta: [{
						url: '',
						name: '综合管理'
					}, {
						url: 'flowList',
						name: '流程审批'
					}]
				},
				{
					path: '/overall/workflow/shenqing_hetong',
					name: 'shenqing_hetong',
					component: shenqing_hetong => require([
						'@/components/overall/workflow/shenqing_hetong.vue'
					], shenqing_hetong),
					meta: [{
						url: '',
						name: '综合管理'
					}, {
						url: '',
						name: '合同申请单'
					}]
				},
				{
					path: '/overall/workflow/shenqing_qingjia',
					name: 'shenqing_qingjia',
					component: shenqing_qingjia => require([
							'@/components/overall/workflow/shenqing_qingjia.vue'
						],
						shenqing_qingjia),
					meta: [{
						url: '',
						name: '综合管理'
					}, {
						url: '',
						name: '请假申请单'
					}]
				},

				{
					path: '/overall/workflow/shenqing_jiaban',
					name: 'shenqing_jiaban',
					component: shenqing_jiaban => require([
							'@/components/overall/workflow/shenqing_jiaban.vue'
						],
						shenqing_jiaban),
					meta: [{
						url: '',
						name: '综合管理'
					}, {
						url: '',
						name: '加班申请单'
					}]
				},
				{
					path: '/overall/workflow/shenqing_lizhi',
					name: 'shenqing_lizhi',
					component: shenqing_lizhi => require([
							'@/components/overall/workflow/shenqing_lizhi.vue'
						],
						shenqing_lizhi),
					meta: [{
						url: '',
						name: '综合管理'
					}, {
						url: '',
						name: '离职申请单'
					}]
				},
				{
					path: '/overall/workflow/shenqing_butie',
					name: 'shenqing_butie',
					component: shenqing_butie => require([
							'@/components/overall/workflow/shenqing_butie.vue'
						],
						shenqing_butie),
					meta: [{
						url: '',
						name: '综合管理'
					}, {
						url: '',
						name: '补贴申请单'
					}]
				},
				{
					path: '/overall/workflow/shenqing_qita',
					name: 'shenqing_qita',
					component: shenqing_qita => require([
						'@/components/overall/workflow/shenqing_qita.vue'
					], shenqing_qita),
					meta: [{
						url: '',
						name: '综合管理'
					}, {
						url: '',
						name: '其他申请单'
					}]
				},


				{
					path: '/overall/workflow/leave',
					name: 'applyLeave',
					component: applyLeave => require(['@/components/overall/workflow/leave'],
						applyLeave),
					meta: [{
						url: '',
						name: '综合管理'
					}, {
						url: '',
						name: '流程审批列表'
					}]
				},


				{
					path: '/overall/email/list',
					name: 'emailList',
					component: emailList => require(['@/components/overall/email/list'], emailList),
					meta: [{
						url: '',
						name: '综合管理'
					}, {
						url: '',
						name: '邮件列表'
					}]
				},
				{
					path: '/overall/trainCourse/list',
					name: 'peixun_info',
					component: peixun_info => require(['@/components/overall/peixun_info'],
						peixun_info),
					meta: {
						breadList: [{
							url: '',
							name: '综合管理'
						}, {
							url: 'peixun_info',
							name: '培训信息'
						}]
					}
				},
				{
					path: '/overall/self_guanli/guanxuan_info_edit',
					name: 'guanxuan_info_edit',
					component: guanxuan_info_edit => require([
							'@/components/overall/self_guanli/guanxuan_info_edit'
						],
						guanxuan_info_edit),
					meta: {
						breadList: [{
							url: '',
							name: '综合管理'
						}, {
							url: '',
							name: '官宣编辑'
						}]
					}
				},
				{
					path: '/overall/self_guanli/guanxuan_info_edit2',
					name: 'guanxuan_info_edit2',
					component: guanxuan_info_edit2 => require([
							'@/components/overall/self_guanli/guanxuan_info_edit2'
						],
						guanxuan_info_edit2),
					meta: {
						breadList: [{
							url: '',
							name: '综合管理'
						}, {
							url: '',
							name: '官宣编辑'
						}]
					}
				},


				{
					path: '/overall/self_guanli/self_guanli_index',
					name: 'self_guanli_index',
					component: self_guanli_index => require([
							'@/components/overall/self_guanli/self_guanli_index'
						],
						self_guanli_index),
					meta: [{
						url: '',
						name: '综合管理'
					}, {
						url: '',
						name: '个人管理'
					}],
					redirect: {
						name: 'self_info'
					},
					children: [{
						path: '/overall/self_guanli/self_info',
						name: 'self_info',
						component: self_info => require([
							'@/components/overall/self_guanli/self_info'
						], self_info),
					}, {
						path: '/overall/self_guanli/guanxuan_info',
						name: 'guanxuan_info',
						component: guanxuan_info => require([
							'@/components/overall/self_guanli/guanxuan_info'
						], guanxuan_info),
					}, {
						path: '/overall/self_guanli/work_conmment',
						name: 'work_conmment',
						component: work_conmment => require([
							'@/components/overall/self_guanli/work_conmment'
						], work_conmment),
					}, {
						path: '/overall/self_guanli/mumiao',
						name: 'mumiao',
						component: mumiao => require([
							'@/components/overall/self_guanli/mumiao'], mumiao),
					}, {
						path: '/overall/self_guanli/self_peixun_info',
						name: 'self_peixun_info',
						component: self_peixun_info => require([
								'@/components/overall/self_guanli/self_peixun_info'
							],
							self_peixun_info),
					}, {
						path: '/overall/self_guanli/work_tongji',
						name: 'work_tongji',
						component: work_tongji => require([
							'@/components/overall/self_guanli/work_tongji'
						], work_tongji),
					}, {
						path: '/overall/self_guanli/self_caiwu',
						name: 'self_caiwu',
						component: self_caiwu => require([
							'@/components/overall/self_guanli/self_caiwu'
						], self_caiwu),
					}, ]
				},
				
				
				{
					path: '/overall/self_guanli/self_publicize',
					name: 'self_publicize',
					component: self_publicize => require([
							'@/components/overall/self_guanli/self_publicize'
						],
						self_publicize),
					meta: [{
						url: '',
						name: '综合管理'
					}, {
						url: '',
						name: '个人管理'
					}],
				
				},

				{
					path: '/intergrate/office/list',
					name: 'innerJob',
					component: innerJob => require(['@/components/integrate/office/list'], innerJob),
					meta: [{
						url: '',
						name: '综合管理'
					}, {
						url: '',
						name: '内务府'
					}]
				},
				{
					path: '/intergrate/company/list',
					name: 'addressBook',
					component: addressBook => require(['@/components/integrate/company/list'],
						addressBook),
					meta: [{
						url: '',
						name: '综合管理'
					}, {
						url: '',
						name: '企业通讯录'
					}]
				},
				{
					path: '/intergrate/staff/list',
					name: 'employeeAddressBook',
					component: employeeAddressBook => require(['@/components/integrate/staff/list'],
						employeeAddressBook),
					meta: [{
						url: '',
						name: '综合管理'
					}, {
						url: '',
						name: '员工通讯录'
					}]
				},
				/***/
				{
					path: '/employee/profile',
					name: 'employeeProfile',
					component: employeeProfile => require(['@/components/overall/userProfile/index'],
						employeeProfile),
					meta: [{
						url: '',
						name: '综合管理'
					}, {
						url: '',
						name: '个人管理'
					}]
				},


				/******** 电信管理 *********/
				{
					path: '/phone/advise',
					name: 'advise',
					component: advise => require(['@/components/phone/advise.vue'], advise),
					meta: [{
						url: '',
						name: '电信管理'
					}, {
						url: '',
						name: '投诉建议'
					}]
				},

				{
					path: '/phone/Function',
					name: 'Function',
					component: Function => require(['@/components/phone/Function.vue'], Function),
					meta: [{
						url: '',
						name: '电信管理'
					}, {
						url: '',
						name: '功能说明'
					}]
					// redirect: {
					// 	name: 'function_zonghe'
					// },
					// children: [{
					// 	path: '/phone/function_zonghe',
					// 	name: 'function_zonghe',
					// 	component: function_zonghe => require(['@/components/phone/function_zonghe.vue'], function_zonghe),
					// }]
				},

				{
					path: '/phone/setting/phoneSetting_index',
					name: 'phoneSetting_index',
					component: phoneSetting_index => require([
							'@/components/phone/setting/phoneSetting_index.vue'
						],
						phoneSetting_index),
					meta: [{
						url: '',
						name: '电信管理'
					}, {
						url: '',
						name: '系统设置'
					}],
					redirect: {
						name: 'phoneSetting_user'
					},
					children: [{
							path: '/phone/setting/phoneSetting_diary',
							name: 'phoneSetting_diary',
							component: phoneSetting_diary => require([
									'@/components/phone/setting/phoneSetting_diary.vue'
								],
								phoneSetting_diary),
							meta: [{
								url: '',
								name: '电信管理'
							}, {
								url: '',
								name: '日志管理'
							}],
						}, {
							path: '/phone/setting/phoneSetting_pc',
							name: 'phoneSetting_pc',
							component: phoneSetting_pc => require([
									'@/components/phone/setting/phoneSetting_pc.vue'
								],
								phoneSetting_pc),
							meta: [{
								url: '',
								name: '电信管理'
							}, {
								url: '',
								name: '电脑管理'
							}],
						}, {
							path: '/phone/setting/phoneSetting_power',
							name: 'phoneSetting_power',
							component: phoneSetting_power => require([
									'@/components/phone/setting/phoneSetting_power.vue'
								],
								phoneSetting_power),
							meta: [{
								url: '',
								name: '电信管理'
							}, {
								url: '',
								name: '授权管理'
							}],
						},

						{
							path: '/phone/setting/sysMenu',
							name: 'sysMenu',
							component: sysMenu => require(['@/components/phone/setting/menu.vue'],
								sysMenu),
							meta: [{
								url: '',
								name: '电信管理'
							}, {
								url: '',
								name: '菜单管理'
							}],
						},


						{
							path: '/phone/setting/phoneSetting_user',
							name: 'phoneSetting_user',
							component: phoneSetting_user => require([
									'@/components/phone/setting/phoneSetting_user.vue'
								],
								phoneSetting_user),
							meta: [{
								url: '',
								name: '电信管理'
							}, {
								url: '',
								name: '用户管理'
							}],
						},
						{
							path: '/phone/setting/phoneSetting_fenbu',
							name: 'phoneSetting_fenbu',
							component: phoneSetting_fenbu => require([
									'@/components/phone/setting/phoneSetting_fenbu.vue'
								],
								phoneSetting_fenbu),
							meta: [{
								url: '',
								name: '电信管理'
							}, {
								url: '',
								name: '分布管理'
							}],
						}
					]
				},





				/******** 市场管理 *********/
				{
					path: '/market/market_index',
					name: 'market_index',
					component: market_index => require(['@/components/market/market_index.vue'],
						market_index),
					meta: [{
						url: '',
						name: '市场管理'
					}, {
						url: '',
						name: '建科客户库'
					}]
				},
				{
					path: '/market/market_statistics',
					name: 'market_statistics',
					component: market_statistics => require([
						'@/components/market/market_statistics.vue'], market_statistics),
					meta: [{
						url: '',
						name: '制度流程'
					}, {
						url: '',
						name: '商务指南'
					}]
				},
				{
					path: '/market/lawyerExam',
					name: 'lawyerExam',
					component: lawyerExam => require([
						'@/components/market/lawyerExam.vue'], lawyerExam),
					meta: [{
						url: '',
						name: '制度流程'
					}, {
						url: '',
						name: '律师考试'
					}]
				},
				{
					path: '/market/businessExam',
					name: 'businessExam',
					component: businessExam => require([
						'@/components/market/businessExam.vue'], businessExam),
					meta: [{
						url: '',
						name: '制度流程'
					}, {
						url: '',
						name: '商务考试'
					}]
				},
				{
					path: '/market/legalExam',
					name: 'legalExam',
					component: legalExam => require([
						'@/components/market/legalExam.vue'], legalExam),
					meta: [{
						url: '',
						name: '制度流程'
					}, {
						url: '',
						name: '法务考试'
					}]
				},
				
				
				{
					path: '/market/personnel_process',
					name: 'personnel_process',
					component: personnel_process => require([
						'@/components/market/personnel_process.vue'], personnel_process),
					meta: [{
						url: '',
						name: '制度流程'
					}, {
						url: '',
						name: '人事流程'
					}]
				},
				
				
				{
					path: '/legal/guide',
					name: 'legal_guide',
					component: legal_guide => require(['@/components/market/legal_guide.vue'],
						legal_guide),
					meta: [{
						url: '',
						name: '制度流程'
					}, {
						url: '',
						name: '法务指南'
					}]
				},
				{
					path: '/market/market_report',
					name: 'market_report',
					component: market_report => require(['@/components/market/market_report.vue'],
						market_report),
					meta: [{
						url: '',
						name: '市场管理'
					}, {
						url: '',
						name: '商务报表'
					}]
				},



				/******** 人事管理 *********/
				{
					path: '/personnel/frame/list',
					name: 'personnelFrame',
					component: personnelFrame => require(['@/components/personnel/frame/list.vue'],
						personnelFrame),
					meta: [{
						url: '',
						name: '人事管理'
					}, {
						url: '',
						name: '管理架构'
					}]
				},
				{
					path: '/personnel/employee/list',
					name: 'employeeList',
					component: employeeList => require(['@/components/personnel/employee/list.vue'],
						employeeList),
					meta: [{
						url: '',
						name: '人事管理'
					}, {
						url: '',
						name: '员工列表'
					}]
				},


				{
					path: '/personnel/employee/laborRelation',
					name: 'laborRelation',
					component: laborRelation => require([
						'@/components/personnel/employee/laborRelation.vue'
					], laborRelation),
					meta: [{
						url: '',
						name: '人事管理'
					}, {
						url: '',
						name: '劳动关系'
					}]
				},
				{
					path: '/personnel/employee/trainManagement',
					name: 'trainManagement',
					component: trainManagement => require([
							'@/components/personnel/employee/trainCourse/trainManagement.vue'
						],
						trainManagement),
					meta: [{
						url: '',
						name: '人事管理'
					}, {
						url: '',
						name: '培训管理'
					}]
				},

				{
					path: '/personnel/employee/candidate',
					name: 'candidate',
					component: candidate => require(['@/components/personnel/employee/candidate.vue'],
						candidate),
					meta: [{
						url: '',
						name: '人事管理'
					}, {
						url: '',
						name: '招聘管理'
					}]
				},

				{
					path: '/personnel/employee/statistics',
					name: 'statistics',
					component: statistics => require(['@/components/personnel/employee/statistics.vue'],
						statistics),
					meta: [{
						url: '',
						name: '人事管理'
					}, {
						url: '',
						name: '人事统计'
					}]
				},
				{
					path: '/personnel/employee/candidateDetail',
					name: 'candidateDetail',
					component: candidateDetail => require([
						'@/components/personnel/employee/candidateDetail.vue'
					], candidateDetail),
					meta: [{
						url: '',
						name: '人事管理'
					}, {
						url: '',
						name: '候选人详情'
					}]
				},
				/******** 市场管理中的客户库   见下 *********/
				{
					path: '/market/my_kehu/market_kehu_index',
					name: 'market_kehu_index',
					component: market_kehu_index => require([
							'@/components/market/my_kehu/market_kehu_index.vue'
						],
						market_kehu_index),
					meta: [{
						url: '',
						name: '市场管理'
					}, {
						url: '',
						name: '我的客户库'
					}],
					redirect: {
						name: 'market_my_kehu'
					},

					children: [{
							path: '/market/my_kehu/market_static_table',
							name: 'market_static_table',
							component: () =>
								import("@/components/market/my_kehu/market_static_table"),
							meta: {
								title: "建科客户库统计表",
								url: '',
								index: "0"
							}
						},
						{
							path: '/market/my_kehu/market_my_kehu',
							name: 'market_my_kehu',
							component: () =>
								import("@/components/market/my_kehu/market_my_kehu.vue"),
							meta: {
								title: "客户库",
								url: '',
								index: "1"
							}
						}, {
							path: '/market/my_kehu/market_kehu_fenxi',
							name: 'market_kehu_fenxi',
							component: () =>
								import("@/components/market/my_kehu/market_kehu_fenxi.vue"),
							meta: {
								title: "客户库分析",
								url: '',
								index: "2"
							}
						},
						{
							path: '/market/my_kehu/market_work_calendar',
							name: 'market_work_calendar',
							component: () =>
								import("@/components/market/my_kehu/market_work_calendar.vue"),
							meta: {
								title: "市场工作日历",
								url: '',
								index: ""
							}
						}, {
							path: '/market/my_kehu/market_chuRuKu',
							name: 'market_chuRuKu',
							component: () =>
								import("@/components/market/my_kehu/market_chuRuKu.vue"),
							meta: {
								title: "出入库记录",
								url: '',
								index: "4"
							}
						}, {
							path: '/market/my_kehu/market_quanXian',
							name: 'market_quanXian',
							component: () =>
								import("@/components/market/my_kehu/market_quanXian.vue"),
							meta: {
								title: "权限记录",
								url: '',
								index: "5"
							}
						},
					],
				},
				/******** 市场管理中的客户库   见上 *********/




				/******** 商务管理 *********/
				{
					path: '/business/my_kehu/kehu_index',
					name: 'kehu_index',
					component: kehu_index => require(['@/components/business/my_kehu/kehu_index.vue'],
						kehu_index),
					meta: [{
						url: '',
						name: '商务管理'
					}, {
						url: '',
						name: '我的客户库'
					}],
					redirect: {
						name: 'my_kehu'
					},

					children: [{
							path: '/business/my_kehu/my_kehu',
							name: 'my_kehu',
							component: () =>
								import("@/components/business/my_kehu/my_kehu.vue"),
							meta: {
								title: "客户库",
								url: '',
								index: "1"
							}
						}, {
							path: '/business/my_kehu/kehu_fenxi',
							name: 'kehu_fenxi',
							component: () =>
								import("@/components/business/my_kehu/kehu_fenxi.vue"),
							meta: {
								title: "客户库分析",
								url: '',
								index: "2"
							}
						}, {
							path: '/business/my_kehu/work_calendar',
							name: 'work_calendar',
							component: () =>
								import("@/components/business/my_kehu/work_calendar.vue"),
							meta: {
								title: "客户工作日历",
								url: '',
								index: "3"
							}
						},
						{
							path: '/business/my_kehu/chuRuKu',
							name: 'chuRuKu',
							component: () =>
								import("@/components/business/my_kehu/chuRuKu.vue"),
							meta: {
								title: "出入库记录",
								url: '',
								index: "4"
							}
						}, {
							path: '/business/my_kehu/quanXian',
							name: 'quanXian',
							component: () =>
								import("@/components/business/my_kehu/quanXian.vue"),
							meta: {
								title: "权限记录",
								url: '',
								index: "5"
							}
						},
					],
				},

				{
					path: '/business/public_kehu',
					name: 'public_kehu',
					component: public_kehu => require(['@/components/business/original_kehu.vue'],
						public_kehu),
					meta: {
						breadList: [{
							url: '',
							name: '商务管理'
						}, {
							url: 'public_kehu',
							name: '公共客户库'
						}]
					}
				},
				{
					path: '/business/all_kehu',
					name: 'all_kehu',
					component: all_kehu => require(['@/components/business/original_kehu.vue'],
						all_kehu),
					meta: {
						breadList: [{
							url: '',
							name: '市场管理'
						}, {
							url: 'public_kehu',
							name: '全部客户库'
						}]
					}
				},

				{
					path: '/business/wuxiao_kehu',
					name: 'wuxiao_kehu',
					component: wuxiao_kehu => require(['@/components/business/original_kehu'],
						wuxiao_kehu),
					meta: {
						breadList: [{
							url: '',
							name: '商务管理'
						}, {
							url: 'wuxiao_kehu',
							name: '无效客户库'
						}]
					}
				},
				{
					path: '/business/original_kehu',
					name: 'original_kehu',
					component: original_kehu => require(['@/components/business/original_kehu.vue'],
						original_kehu),
					meta: {
						breadList: [{
							url: '',
							name: '商务管理'
						}, {
							url: 'original_kehu',
							name: '原始客户库'
						}]
					}
				},
				{
					path: '/business/negative_list',
					name: 'negative_list',
					component: negative_list => require(['@/components/business/original_kehu.vue'],
						negative_list),
					meta: {
						breadList: [{
							url: '',
							name: '商务管理'
						}, {
							url: 'negative_list',
							name: '负面清单库'
						}]
					}
				},
				{
					path: '/business/tuijian_kehu',
					name: 'tuijian_kehu',
					component: tuijian_kehu => require(['@/components/business/original_kehu.vue'],
						tuijian_kehu),
					meta: {
						breadList: [{
							url: '',
							name: '商务管理'
						}, {
							url: 'tuijian_kehu',
							name: '推荐客户库'
						}]
					}
				},
				{
					path: '/business/zhongzhuan_kehu',
					name: 'zhongzhuan_kehu',
					component: zhongzhuan_kehu => require(['@/components/business/original_kehu.vue'],
						zhongzhuan_kehu),
					meta: {
						breadList: [{
							url: '',
							name: '商务管理'
						}, {
							url: 'zhongzhuan_kehu',
							name: '中转客户库'
						}]
					}
				},
				{
					path: '/business/business_report',
					name: 'business_report',
					component: business_report => require(['@/components/business/business_report.vue'],
						business_report),
					meta: {
						breadList: [{
							url: '',
							name: '商务管理'
						}, {
							url: 'business_report',
							name: '商务报表'
						}]
					}
				},

				// 下面是法律数据模块
				{
					path: '/app/question/list',
					name: 'app_question_list',
					component: app_question_list => require(['@/components/app/app_question_list.vue'],
						app_question_list),
					meta: [{
						url: '',
						name: 'app界面'
					}, {
						url: '',
						name: '问答列表'
					}],

				},

				{
					path: '/legal_data/legal_risk',
					name: 'legal_risk',
					component: legal_risk => require(['@/components/legal_data/legal_risk.vue'],
						legal_risk),
					meta: [{
						url: '',
						name: '法律数据'
					}, {
						url: '',
						name: '法律风险数据库'
					}],

				},
				{
					path: '/legal_data/legal_answer',
					name: 'legal_answer',
					component: legal_answer => require(['@/components/legal_data/legal_answer.vue'],
						legal_answer),
					meta: [{
						url: '',
						name: '法律数据'
					}, {
						url: '',
						name: '建科法律问答库'
					}],

				},
				{
					path: '/legal_data/legal_article',
					name: 'legal_article',
					component: legal_article => require(['@/components/legal_data/legal_article.vue'],
						legal_article),
					meta: [{
						url: '',
						name: '法律数据'
					}, {
						url: '',
						name: '建科法律文摘库'
					}],

				},
				{
					path: '/legal_data/legal_lawyer',
					name: 'legal_lawyer',
					component: legal_lawyer => require(['@/components/legal_data/legal_lawyer.vue'],
						legal_lawyer),
					meta: [{
						url: '',
						name: '法律数据'
					}, {
						url: '',
						name: '建科联盟律师库'
					}],

				},
				{
					path: '/legal_data/legal_moban',
					name: 'legal_moban',
					component: legal_moban => require(['@/components/legal_data/legal_moban.vue'],
						legal_moban),
					meta: [{
						url: '',
						name: '法律数据'
					}, {
						url: '',
						name: '建科法律模板库'
					}],

				},

				// 下面是投资者管理
				{
					path: '/investor/investor_setting',
					name: 'investor_setting',
					component: investor_setting => require([
						'@/components/investor/investor_setting.vue'], investor_setting),
					meta: [{
						url: '',
						name: '投资者管理'
					}, {
						url: '',
						name: '投资者设置'
					}],
				},
				{
					path: '/investor/investor_caiwu',
					name: 'investor_caiwu',
					component: investor_caiwu => require(['@/components/investor/investor_caiwu.vue'],
						investor_caiwu),
					meta: [{
						url: '',
						name: '投资者管理'
					}, {
						url: '',
						name: '投资者财务'
					}],
				},
				{
					path: '/investor/investor_shangwu',
					name: 'investor_shangwu',
					component: investor_shangwu => require([
						'@/components/investor/investor_shangwu.vue'], investor_shangwu),
					meta: [{
						url: '',
						name: '投资者管理'
					}, {
						url: '',
						name: '投资者商务'
					}],
				},
				{
					path: '/investor/investor_renshi',
					name: 'investor_renshi',
					component: investor_renshi => require(['@/components/investor/investor_renshi.vue'],
						investor_renshi),
					meta: [{
						url: '',
						name: '投资者管理'
					}, {
						url: '',
						name: '投资者人事'
					}],
				},



				/******** 客户界面 *********/
				{
					path: '/custom/kehu_falv_fuwu',
					name: 'kehu_falv_fuwu',
					component: kehu_falv_fuwu => require(['@/components/custom/kehu_falv_fuwu.vue'],
						kehu_falv_fuwu),
					meta: [{
						url: '',
						name: '客户界面'
					}, {
						url: '',
						name: '法律服务'
					}]
				},
				{
					path: '/custom/kehu_fuwu_hetong',
					name: 'kehu_fuwu_hetong',
					component: kehu_fuwu_hetong => require(['@/components/custom/kehu_fuwu_hetong.vue'],
						kehu_fuwu_hetong),
					meta: [{
						url: '',
						name: '客户界面'
					}, {
						url: '',
						name: '服务合同'
					}]
				},
				{
					path: '/custom/kehu_success',
					name: 'kehu_success',
					component: kehu_success => require(['@/components/custom/kehu_success.vue'], kehu_success),
					meta: [{
						url: '',
						name: '客户界面'
					}, {
						url: '',
						name: '胜败之道'
					}]
				},
				{
					path: '/custom/kehu_tel',
					name: 'kehu_tel',
					component: kehu_tel => require(['@/components/custom/kehu_tel.vue'], kehu_tel),
					meta: [{
						url: '',
						name: '客户界面'
					}, {
						url: '',
						name: '通讯录'
					}]
				},
				{
					path: '/overall/teamwork/list',
					name: 'teamworkList',
					component: teamworkList => require(['@/components/overall/teamwork/list.vue'], teamworkList),
					meta: [{
						url: '',
						name: '协同管理'
					}, {
						url: '',
						name: '团队列表'
					}]
				},
				{
					path: '/overall/teamwork/mylist',
					name: 'teamworkMyList',
					component: teamworkMyList => require(['@/components/overall/teamwork/mylist.vue'], teamworkMyList),
					meta: [{
						url: '',
						name: '我的团队'
					}, {
						url: '',
						name: '我的团队'
					}]
				},
				{
					path: '/overall/teamwork/myFinance',
					name: 'myFinance',
					component: myFinance => require(['@/components/overall/teamwork/myFinance.vue'], myFinance),
					meta: [{
						url: '',
						name: '我的财务'
					}, {
						url: '',
						name: '我的财务'
					}]
				},
				{
					path: '/overall/teamwork/list_account',
					name: 'accountList',
					component: accountList => require(['@/components/overall/teamwork/list_account.vue'], accountList),
					meta: [{
						url: '',
						name: '账号管理'
					}, {
						url: '',
						name: '账号列表'
					}]
				},
				
				
				{
					path: '/custom/kehu_case_shuli',
					name: 'kehu_case_shuli',
					component: kehu_case_shuli => require(['@/components/custom/kehu_case_shuli.vue'],
						kehu_case_shuli),
				},

				{
					path: '/custom/kehu_fuwu_hetong2',
					name: 'kehu_fuwu_hetong2',
					component: kehu_fuwu_hetong2 => require([
						'@/components/custom/kehu_fuwu_hetong2.vue'], kehu_fuwu_hetong2),
				},

				{
					path: '/finance/caiwu_pingzheng',
					name: 'caiwu_pingzheng',
					// component: caiwu_pingzheng => require(["@/components/finance/finance_report/pingzheng_detail.vue"], caiwu_pingzheng),
					component: caiwu_pingzheng => require(["@/components/finance/caiwu_pingzheng.vue"],
						caiwu_pingzheng),
					meta: [{
							url: '',
							name: '财务管理'
						},
						{
							url: '',
							name: '财务凭证'
						}
					]
				},
				{
					path: '/finance/caiwu_zhanghao',
					name: 'caiwu_zhanghao',
					component: caiwu_zhanghao => require(["@/components/finance/caiwu_zhanghao.vue"],
						caiwu_zhanghao),
					meta: [{
						url: '',
						name: '财务管理'
					}, {
						url: '',
						name: '财务账号'
					}]
				},
				{
					path: '/finance/kaipiao_jilu',
					name: 'kaipiao_jilu',
					component: kaipiao_jilu => require(["@/components/finance/kaipiao_jilu.vue"],
						kaipiao_jilu),
					meta: [{
						url: '',
						name: '财务管理'
					}, {
						url: '',
						name: '开票记录'
					}]
				},
				{
					path: '/finance/baoxiao_jilu',
					name: 'baoxiao_jilu',
					component: baoxiao_jilu => require(["@/components/finance/baoxiao_jilu.vue"],
						baoxiao_jilu),
					meta: [{
						url: '',
						name: '财务管理'
					}, {
						url: '',
						name: '报销记录'
					}]
				},
				{
					path: '/finance/caiwu_tongji',
					name: 'caiwu_tongji',
					component: caiwu_tongji => require(["@/components/finance/caiwu_tongji.vue"],
						caiwu_tongji),
					meta: [{
						url: '',
						name: '财务管理'
					}, {
						url: '',
						name: '财务统计'
					}]
				},
				{
					path: '/finance/faren_tongji',
					name: 'faren_tongji',
					component: faren_tongji => require(["@/components/finance/faren_tongji.vue"],
						faren_tongji),
					meta: [{
						url: '',
						name: '财务管理'
					}, {
						url: '',
						name: '法人统计'
					}]
				},
				{
					path: '/finance/jidian_tongji',
					name: 'jidian_tongji',
					component: jidian_tongji => require(["@/components/finance/jidian_tongji.vue"],
						jidian_tongji),
					meta: [{
						url: '',
						name: '财务管理'
					}, {
						url: '',
						name: '绩点统计'
					}]
				},
				{
					path: '/finance/caiwu_fenxi',
					name: 'caiwu_fenxi',
					component: caiwu_fenxi => require(["@/components/finance/caiwu_fenxi.vue"],
						caiwu_fenxi),
					meta: [{
						url: '',
						name: '财务管理'
					}, {
						url: '',
						name: '财务分析'
					}]
				},
				{
					path: '/finance/caiwu_shezhi',
					name: 'caiwu_shezhi',
					component: caiwu_shezhi => require(["@/components/finance/caiwu_shezhi.vue"],
						caiwu_shezhi),
					meta: [{
						url: '',
						name: '财务管理'
					}, {
						url: '',
						name: '财务设置'
					}]
				},

				{
					path: '/legal/kehu_xuqiu',
					name: 'kehu_xuqiu',
					component: kehu_xuqiu => require(["@/components/legal/kehu_xuqiu.vue"], kehu_xuqiu),
					meta: [{
						url: '',
						name: '法务管理'
					}, {
						url: '',
						name: '客户需求'
					}]
				},
				{
					path: '/legal/kehu_xuqiu_add',
					name: 'kehu_xuqiu_add',
					component: kehu_xuqiu_add => require(["@/components/legal/kehu_xuqiu_add.vue"],
						kehu_xuqiu_add),
					meta: [{
						url: '',
						name: '法务管理'
					}, {
						url: '',
						name: '客户需求'
					}]
				},
				{
					path: '/legal/hetong_shenpi',
					name: 'hetong_shenpi',
					component: hetong_shenpi => require(["@/components/legal/hetong_shenpi.vue"],
						hetong_shenpi),
					meta: [{
						url: '',
						name: '法务管理'
					}, {
						url: '',
						name: '合同审批'
					}]
				},
				{
					path: '/legal/fawu_list',
					name: 'fawu_list',
					component: fawu_list => require(["@/components/legal/fawu_list.vue"], fawu_list),
					meta: [{
						url: '',
						name: '法务管理'
					}, {
						url: '',
						name: '法务列表'
					}]
				},
				{
					path: '/legal/fawu_list_custom',
					name: 'fawu_list_custom',
					component: fawu_list_custom => require(["@/components/legal/fawu_list_custom.vue"], fawu_list_custom),
					meta: [{
						url: '',
						name: '法务管理'
					}, {
						url: '',
						name: '法务列表'
					}]
				},
				
				
				{
					path: '/legal/contract_list',
					name: 'contract_list',
					component: contract_list => require(["@/components/legal/contract_list.vue"],
						contract_list),
					meta: [{
						url: '',
						name: '合同管理'
					}, {
						url: '',
						name: '合同列表'
					}]
				},
				{
					path: '/legal/fawu_tongji',
					name: 'fawu_tongji',
					component: fawu_tongji => require(["@/components/legal/fawu_tongji.vue"],
						fawu_tongji),
					meta: [{
						url: '',
						name: '法务管理'
					}, {
						url: '',
						name: '法务统计'
					}]
				},
				{
					path: '/legal/fawu_tongji2',
					name: 'fawu_tongji2',
					component: fawu_tongji2 => require(["@/components/legal/fawu_tongji2.vue"],
						fawu_tongji2),
					meta: [{
						url: '',
						name: '法务管理'
					}, {
						url: '',
						name: '法务统计2'
					}]
				}

			]
		},

		// 综合管理->工作日历  后来要求的要单开窗口  (⊙︿⊙)
		{
			path: '/overall/workRecord/calendar',
			name: 'workCalendar',
			component: workCalendar => require(['@/components/overall/workrecord/calendar'], workCalendar),
			meta: {
				breadList: [{
					url: '',
					name: '综合管理'
				}, {
					url: 'workCalendar',
					name: '工作日历'
				}]
			}
		},
		// {
		// 	path: '/view/main/rankingDetail',
		// 	name: 'rankingDetail',
		// 	component: rankingDetail => require(['@/src/view/main/rankingDetail'], rankingDetail),
		// 	meta: [{
		// 		url: '',
		// 		name: '排行详情'
		// 	}]
		// },



		// 基本法独立出来
		{
			path: '/basicLaw',
			name: 'basicLaw',
			component: basicLaw => require(['@/components/overall/basicLaw/detail'], basicLaw),
			meta: [{
				url: '',
				name: '综合管理'
			}, {
				url: '',
				name: '建科基本法'
			}]
		},

		// ******* 案件评估单独模块 **********

		{
			path: '/legal/legal_hetong/hetong_case_index',
			name: 'hetong_case_index',
			component: hetong_case_index => require([
					'@/components/legal/legal_hetong/hetong_case_index.vue'],
				hetong_case_index),
			meta: [{
				url: '',
				name: '法律合同详情'
			}],
			redirect: {
				name: 'case_home'
			},
			children: [{
					path: '/legal/legal_hetong/case_home',
					name: 'case_home',
					component: case_home => require(['@/components/legal/legal_hetong/case_home.vue'],
						case_home),
					meta: [{
						url: '',
						name: '案件管理首页'
					}],
				},
				{
					path: '/legal/legal_hetong/case_tel',
					name: 'case_tel',
					component: case_tel => require(['@/components/legal/legal_hetong/case_tel.vue'],
						case_tel),
					meta: [{
						url: '',
						name: '通讯录'
					}],
				},
				{
					path: '/legal/legal_hetong/case_service_record',
					name: 'case_service_record',
					component: case_service_record => require([
							'@/components/legal/legal_hetong/case_service_record.vue'
						],
						case_service_record),
					meta: [{
						url: '',
						name: '服务记录'
					}],
				},

				{
					path: '/legal/legal_hetong/hetong_case_pinggu',
					name: 'hetong_case_pinggu',
					component: hetong_case_pinggu => require([
							'@/components/legal/legal_hetong/hetong_case_pinggu.vue'
						],
						hetong_case_pinggu),
					meta: [{
						url: '',
						name: '案件评估'
					}],
				},
				
				{
					path: '/legal/legal_hetong/case_work_idea',
					name: 'case_work_idea',
					component: case_work_idea => require([
							'@/components/legal/legal_hetong/case_work_idea.vue'
						],
						case_work_idea),
					meta: [{
						url: '',
						name: '工作感悟'
					}],
				},
				{
					path: '/legal/legal_hetong/case_service_hetong',
					name: 'case_service_hetong',
					component: case_service_hetong => require([
							'@/components/legal/legal_hetong/case_service_hetong.vue'
						],
						case_service_hetong),
					meta: [{
						url: '',
						name: '服务合同'
					}],
				},
				{
					path: '/legal/legal_hetong/case_service_hetong_new',
					name: 'case_service_hetong_new',
					component: case_service_hetong_new => require([
							'@/components/legal/legal_hetong/case_service_hetong_new.vue'
						],
						case_service_hetong_new),
					meta: [{
						url: '',
						name: '服务合同'
					}],
				},
				{
					path: '/legal/legal_hetong/case_service_hetong_custom',
					name: 'case_service_hetong_custom',
					component: case_service_hetong_custom => require([
							'@/components/legal/legal_hetong/case_service_hetong_custom.vue'
						],
						case_service_hetong_custom),
					meta: [{
						url: '',
						name: '客户--服务合同'
					}],
				},
				{
					path: '/legal/legal_hetong/case_revice_summary',
					name: 'case_revice_summary',
					component: case_revice_summary => require([
							'@/components/legal/legal_hetong/case_revice_summary.vue'
						],
						case_revice_summary),
					meta: [{
						url: '',
						name: '财务记录'
					}],
				},
				{
					path: '/legal_data/legal_logical_sorting',
					name: 'legal_logical_sorting',
					component: legal_logical_sorting => require([
						'@/components/legal_data/legal_logical_sorting.vue'
					], legal_logical_sorting),
					meta: [{
						url: '',
						name: '案件梳理'
					}, {
						url: '',
						name: '案件梳理'
					}],
				},
				{
					path: '/legal/legal_hetong/yewu_luntan_contract',
					name: 'yewu_luntan_contract',
					component: yewu_luntan_contract => require([
							'@/components/legal/legal_hetong/yewu_luntan_contract.vue'
						],
						yewu_luntan_contract),
					meta: [{
						url: '',
						name: '业务论坛'
					}],
				},
				{
					path: '/legal/legal_hetong/case_finance_guanli',
					name: 'case_finance_guanli',
					component: case_finance_guanli => require([
							'@/components/legal/legal_hetong/case_finance_guanli.vue'
						],
						case_finance_guanli),
					meta: [{
						url: '',
						name: '财务管理'
					}],
				},
				{
					path: '/legal/legal_hetong/case_ending',
					name: 'case_ending',
					component: case_ending => require([
							'@/components/legal/legal_hetong/case_ending.vue'],
						case_ending),
					meta: [{
						url: '',
						name: '完结批示'
					}],
				},
				{
					path: '/legal/legal_hetong/case_interest_conflict',
					name: 'case_interest_conflict',
					component: case_interest_conflict => require([
							'@/components/legal/legal_hetong/case_interest_conflict.vue'
						],
						case_interest_conflict),
					meta: [{
						url: '',
						name: '利益冲突'
					}],
				},
				{
					path: '/legal/legal_hetong/hetong_case_shuli',
					name: 'hetong_case_shuli',
					component: hetong_case_shuli => require([
							'@/components/legal/legal_hetong/hetong_case_shuli.vue'
						],
						hetong_case_shuli),
					meta: [{
						url: '',
						name: '案件梳理'
					}],
				},
				{
					path: '/legal/legal_hetong/hetong_case_shuli_custom',
					name: 'hetong_case_shuli_custom',
					component: hetong_case_shuli_custom => require([
							'@/components/legal/legal_hetong/hetong_case_shuli_custom.vue'
						],
						hetong_case_shuli_custom),
					meta: [{
						url: '',
						name: '客户---案件梳理'
					}],
				},
				{
					path: '/legal/legal_hetong/hetong_project_shuli_custom',
					name: 'hetong_project_shuli_custom',
					component: hetong_project_shuli_custom => require([
							'@/components/legal/legal_hetong/hetong_project_shuli_custom'
						],
						hetong_project_shuli_custom),
					meta: [{
						url: '',
						name: '客户---项目梳理'
					}],
				},
				{
					path: '/legal/legal_hetong/hetong_adviser_shuli_custom',
					name: 'hetong_adviser_shuli_custom',
					component: hetong_adviser_shuli_custom => require([
							'@/components/legal/legal_hetong/hetong_adviser_shuli_custom.vue'
						],
						hetong_adviser_shuli_custom),
					meta: [{
						url: '',
						name: '客户---顾问梳理'
					}],
				},
				{
					path: '/legal/legal_hetong/hetong_project_shuli',
					name: 'hetong_project_shuli',
					component: hetong_project_shuli => require([
							'@/components/legal/legal_hetong/hetong_project_shuli.vue'
						],
						hetong_project_shuli),
					meta: [{
						url: '',
						name: '项目梳理'
					}],
				},
				{
					path: '/legal/legal_hetong/hetong_adviser_shuli',
					name: 'hetong_adviser_shuli',
					component: hetong_adviser_shuli => require([
							'@/components/legal/legal_hetong/hetong_adviser_shuli.vue'
						],
						hetong_adviser_shuli),
					meta: [{
						url: '',
						name: '顾问梳理'
					}],
				},
				{
					path: '/legal/legal_hetong/caozuo_jilu',
					name: 'caozuo_jilu',
					component: caozuo_jilu => require([
							'@/components/legal/legal_hetong/caozuo_jilu.vue'],
						caozuo_jilu),
					meta: [{
						url: '',
						name: '操作记录'
					}],
				},
				{
					path: '/legal/legal_hetong/hetong_case_logic',
					name: 'hetong_case_logic',
					component: hetong_case_logic => require([
							'@/components/legal/legal_hetong/hetong_case_logic.vue'
						],
						hetong_case_logic),
					meta: [{
						url: '',
						name: '逻辑梳理'
					}],
				},
				{
					path: '/legal/legal_hetong/legal_affairs2',
					name: 'legal_affairs2',
					component: legal_affairs2 => require([
							'@/components/legal/legal_hetong/legal_affairs2.vue'
						],
						legal_affairs2),
					meta: [{
						url: 'legal_affairs2',
						name: '历史记录'
					}],
				},
				{
					path: '/legal_data/legal_risk',
					name: 'case_legal_risk',
					component: case_legal_risk => require(['@/components/legal_data/legal_risk.vue'],
						case_legal_risk),
					meta: [{
						url: '',
						name: '法律数据'
					}, {
						url: '',
						name: '法律风险数据库'
					}],

				},
				{
					path: '/legal_data/legal_logical_tool',
					name: 'legal_logical_tool',
					component: legal_logical_tool => require([
						'@/components/legal_data/legal_logical_tool.vue'
					], legal_logical_tool),
					meta: [{
						url: '',
						name: '法律数据'
					}, {
						url: '',
						name: '逻辑工具'
					}],
				},
				
				{
					path: '/legal_data/case_browsing',
					name: 'case_browsing',
					component: case_browsing => require([
						'@/components/legal_data/case_browsing.vue'
					], case_browsing),
					meta: [{
						url: '',
						name: '案件浏览'
					}, {
						url: '',
						name: '案件浏览'
					}],
				},

			],
		},


		/***********  start 新增工程项目合同 ************/
		{
			path: '/legal/contract/building',
			name: 'buildingContractIndex',
			component: buildingContractIndex => require(['@/components/legal/contract/building/index'],
				buildingContractIndex),
			meta: [{
				url: '',
				name: '工程项目详情'
			}],
			redirect: {
				name: 'buildingHome'
			},
			children: [{
					path: '/legal/contract/buildingHome',
					name: 'buildingHome',
					component: buildingHome => require([
						'@/components/legal/contract/building/home.vue'],
						buildingHome),
					meta: [{
						url: '',
						name: '工程项目首页'
					}],
				},
				{
					path: '/legal/contract/contact',
					name: 'buildingContact',
					component: buildingContact => require([
						'@/components/legal/legal_hetong/case_tel.vue'
					], buildingContact),
					meta: [{
						url: '',
						name: '通讯录'
					}],
				},
				{
					path: '/legal/contract/serviceRecord',
					name: 'buildingServiceRecord',
					component: buildingServiceRecord => require([
							'@/components/legal/legal_hetong/case_service_record.vue'
						],
						buildingServiceRecord),
					meta: [{
						url: '',
						name: '服务记录'
					}],
				},
				{
					path: '/legal/contract/workingMemo',
					name: 'work_beiwang',
					component: work_beiwang => require([
							'@/components/legal/contract/building/workingMemo.vue'
						],
						work_beiwang),
					meta: [{
						url: '',
						name: '工作备忘'
					}],
				},
				{
					path: '/legal/contract/buildingComb',
					name: 'buildingComb',
					component: buildingComb => require([
							'@/components/legal/contract/building/combing.vue'
						],
						buildingComb),
					meta: [{
						url: '',
						name: '案件梳理'
					}],
				},

				{
					path: '/legal/legal_hetong/building_contract',
					name: 'building_contract',
					component: building_contract => require([
							'@/components/legal/legal_hetong/case_service_hetong.vue'
						],
						building_contract),
					meta: [{
						url: '',
						name: '服务合同'
					}],
				},
				{
					path: '/legal/contract/finance',
					name: 'buildingFinance',
					component: buildingFinance => require([
							'@/components/legal/legal_hetong/case_finance_guanli.vue'
						],
						buildingFinance),
					meta: [{
						url: '',
						name: '财务管理'
					}],
				},
				{
					path: '/legal/legal_hetong/case_ending',
					name: 'buildingEnding',
					component: buildingEnding => require([
							'@/components/legal/legal_hetong/case_ending.vue'
						],
						buildingEnding),
					meta: [{
						url: '',
						name: '完结批示'
					}],
				},
				{
					path: '/legal/legal_hetong/case_interest_conflict',
					name: 'buildingInterestConflict',
					component: buildingInterestConflict => require([
							'@/components/legal/legal_hetong/case_interest_conflict.vue'
						],
						buildingInterestConflict),
					meta: [{
						url: '',
						name: '利益冲突'
					}],
				}, {
					path: '/legal_data/legal_risk',
					name: 'build_legal_risk',
					component: build_legal_risk => require(['@/components/legal_data/legal_risk.vue'],
						build_legal_risk),
					meta: [{
						url: '',
						name: '法律数据'
					}, {
						url: '',
						name: '法律风险数据库'
					}],

				},

			],
		},
		/***********  end 新增工程项目合同 ************/

		// ******* 单独的客户界面 **********
		
		{
			path: '/alone_custom/alone_custom_index',
			name: 'alone_custom_index',
			component: alone_custom_index => require(['@/components/alone_custom/alone_kehu_index.vue'],
				alone_custom_index),
			meta: [{
				url: '',
				name: '单独的客户界面'
			}],
			redirect: {
				name: 'alone_kehu_tel'
			},
			children: [{
					path: '/alone_custom/alone_kehu_tel',
					name: 'alone_kehu_tel',
					component: alone_kehu_tel => require(['@/components/alone_custom/alone_kehu_tel'],
						alone_kehu_tel),
					meta: [{
						url: '',
						name: '客户单独页面  通讯录'
					}],
				},
				{
					path: '/alone_custom/alone_kehu_fuwu_hetong',
					name: 'alone_kehu_fuwu_hetong',
					component: alone_kehu_fuwu_hetong => require([
							'@/components/alone_custom/alone_kehu_fuwu_hetong'
						],
						alone_kehu_fuwu_hetong),
					meta: [{
						url: '',
						name: '客户单独页面  服务合同'
					}],
				},
				{
					path: '/alone_custom/alone_kehu_fuwu_hetong2',
					name: 'alone_kehu_fuwu_hetong2',
					component: alone_kehu_fuwu_hetong2 => require([
							'@/components/alone_custom/alone_kehu_fuwu_hetong2'
						],
						alone_kehu_fuwu_hetong2),
					meta: [{
						url: '',
						name: '客户单独页面  服务合同 除案件 点击详情'
					}],
				},
				{
					path: '/alone_custom/alone_kehu_case_shuli',
					name: 'alone_kehu_case_shuli',
					component: alone_kehu_case_shuli => require([
							'@/components/alone_custom/alone_kehu_case_shuli'
						],
						alone_kehu_case_shuli),
					meta: [{
						url: '',
						name: '客户单独页面  服务合同 案件点击详情'
					}],
				},
				{
					path: '/alone_custom/alone_kehu_falv_fuwu',
					name: 'alone_kehu_falv_fuwu',
					component: alone_kehu_falv_fuwu => require([
							'@/components/alone_custom/alone_kehu_falv_fuwu'
						],
						alone_kehu_falv_fuwu),
					meta: [{
						url: '',
						name: '客户单独页面  法律服务'
					}],
				},
				{
					path: '/alone_custom/alone_kehu_falv_shiwu',
					name: 'alone_kehu_falv_shiwu',
					component: alone_kehu_falv_shiwu => require([
							'@/components/alone_custom/alone_kehu_falv_shiwu'
						],
						alone_kehu_falv_shiwu),
					meta: [{
						url: '',
						name: '客户单独页面  法律事务'
					}],
				},
				{
					path: '/alone_custom/ku/alone_kehu_risk',
					name: 'alone_kehu_risk',
					component: alone_kehu_risk => require([
							'@/components/alone_custom/ku/alone_kehu_risk'
						],
						alone_kehu_risk),
					meta: [{
						url: '',
						name: '客户单独页面  法律风险'
					}],
				},
				{
					path: '/alone_custom/ku/alone_kehu_moban',
					name: 'alone_kehu_moban',
					component: alone_kehu_moban => require([
							'@/components/alone_custom/ku/alone_kehu_moban'
						],
						alone_kehu_moban),
					meta: [{
						url: '',
						name: '客户单独页面  法律模板'
					}],
				},
				{
					path: '/alone_custom/ku/alone_kehu_wenzhai',
					name: 'alone_kehu_wenzhai',
					component: alone_kehu_wenzhai => require([
							'@/components/alone_custom/ku/alone_kehu_wenzhai'
						],
						alone_kehu_wenzhai),
					meta: [{
						url: '',
						name: '客户单独页面  法律文摘'
					}],
				},
				{
					path: '/alone_custom/ku/alone_kehu_laywer',
					name: 'alone_kehu_laywer',
					component: alone_kehu_laywer => require([
							'@/components/alone_custom/ku/alone_kehu_laywer'
						],
						alone_kehu_laywer),
					meta: [{
						url: '',
						name: '客户单独页面  律师联盟'
					}],
				},

			],
		},

		// ******* 法务顾问合同详情 **********
		{
			path: '/legal/legal_hetong/detail_index',
			name: 'detail_index',
			component: detail_index => require(['@/components/legal/legal_hetong/detail_index.vue'],
				detail_index),
			meta: [{
				url: '',
				name: '法律合同详情'
			}],
			// redirect: {
			// 	name: 'guwen_home'
			// },
			children: [{
					path: '/legal/legal_hetong/guwen_home',
					name: 'guwen_home',
					component: guwen_home => require(['@/components/legal/legal_hetong/guwen_home.vue'],
						guwen_home),
					meta: {
						url: 'guwen_home',
						name: '顾问首页'
					},
				},
				{
					path: '/legal/legal_hetong/waibao_home',
					name: 'waibao_home',
					component: waibao_home => require([
							'@/components/legal/legal_hetong/waibao_home.vue'],
						waibao_home),
					meta: {
						url: 'waibao_home',
						name: '外包首页'
					},
				},
				{
					path: '/legal/legal_hetong/xiangmu_home',
					name: 'xiangmu_home',
					component: xiangmu_home => require([
							'@/components/legal/legal_hetong/xiangmu_home.vue'
						],
						xiangmu_home),
					meta: {
						url: 'xiangmu_home',
						name: '项目首页'
					},
				},
				// {
				// 	path: '/legal/legal_hetong/case_home',
				// 	name: 'case_home',
				// 	component: case_home => require(['@/components/legal/legal_hetong/case_home.vue'],
				// 		case_home),
				// 	meta: [{
				// 		url: '',
				// 		name: '案件管理首页'
				// 	}],
				// },
				{
					path: '/legal/legal_hetong/tel',
					name: 'tel',
					component: tel => require(['@/components/legal/legal_hetong/tel.vue'],
						tel),
					meta: {
						url: 'tel',
						name: '通讯录'
					},
				},
				{
					path: '/legal/legal_hetong/service_record',
					name: 'service_record',
					component: service_record => require([
							'@/components/legal/legal_hetong/service_record.vue'
						],
						service_record),
					meta: {
						url: 'service_record',
						name: '服务记录'
					},
				},
				{
					path: '/legal/legal_hetong/legal_affairs',
					name: 'legal_affairs',
					component: legal_affairs => require([
							'@/components/legal/legal_hetong/legal_affairs.vue'
						],
						legal_affairs),
					meta: {
						url: 'legal_affairs',
						name: '法律事务'
					},
				},
				{
					path: '/legal/legal_hetong/revice_summary',
					name: 'revice_summary',
					component: revice_summary => require([
							'@/components/legal/legal_hetong/revice_summary.vue'
						],
						revice_summary),
					meta: {
						url: 'revice_summary',
						name: '服务总结'
					},
				},
				{
					path: '/legal/legal_hetong/work_idea',
					name: 'work_idea',
					component: work_idea => require(['@/components/legal/legal_hetong/work_idea.vue'],
						work_idea),
					meta: {
						url: 'work_idea',
						name: '工作感悟'
					},
				}, {
					path: '/legal_data/legal_risk',
					name: 'contract_legal_risk',
					component: contract_legal_risk => require([
						'@/components/legal_data/legal_risk.vue'], contract_legal_risk),
					meta: [{
						url: '',
						name: '法律数据'
					}, {
						url: '',
						name: '法律风险数据库'
					}],

				},

				/** 合同详情 - 合作评估 */
				{
					path: '/legal/contract/coopEvaluate',
					name: 'coopEvaluate',
					component: coopEvaluate => require([
							'@/components/legal/legal_hetong/coopEvaluate.vue'
						],
						coopEvaluate),
					meta: {
						url: 'coopEvaluate',
						name: '合作评估'
					},
				},
				{
					path: '/legal/legal_hetong/service_hetong',
					name: 'service_hetong',
					component: service_hetong => require([
							'@/components/legal/legal_hetong/case_service_hetong.vue'
						],
						service_hetong),
					meta: {
						url: 'service_hetong',
						name: '服务合同'
					},
				},
				{
					path: '/legal/legal_hetong/finance_guanli',
					name: 'finance_guanli',
					component: finance_guanli => require([
							'@/components/legal/legal_hetong/case_finance_guanli.vue'
						],
						finance_guanli),
					meta: {
						url: 'finance_guanli',
						name: '财务管理'
					},
				},
				{
					path: '/legal/legal_hetong/ending',
					name: 'ending',
					component: ending => require(['@/components/legal/legal_hetong/ending.vue'],
						ending),
					meta: {
						url: 'ending',
						name: '完结批示'
					},
				},
				{
					path: '/legal/legal_hetong/interest_conflict',
					name: 'interest_conflict',
					component: interest_conflict => require([
							'@/components/legal/legal_hetong/interest_conflict.vue'
						],
						interest_conflict),
					meta: {
						url: 'interest_conflict',
						name: '利益冲突'
					},
				},
			],
		},

		{
			path: '/business/kehu_detail/kehu_detail_index',
			name: 'kehu_detail_index',
			component: kehu_detail_index => require([
					'@/components/business/kehu_detail/kehu_detail_index.vue'
				],
				kehu_detail_index),
			meta: [{
				url: '',
				name: '企业信息'
			}],
			redirect: {
				name: 'qiye_info'
			},

			children: [{
					path: '/business/kehu_detail/qiye_info',
					name: 'qiye_info',
					component: qiye_info => require(['@/components/business/kehu_detail/qiye_info.vue'],
						qiye_info),
					meta: [{
						url: '',
						name: ''
					}, {
						url: '',
						name: '企业信息'
					}]
				}, {
					path: '/business/kehu_detail/zhuanyi_jilu',
					name: 'zhuanyi_jilu',
					component: zhuanyi_jilu => require([
						'@/components/business/kehu_detail/zhuanyi_jilu.vue'
					], zhuanyi_jilu),
					meta: [{
						url: '',
						name: '转移记录'
					}]
				},
				{
					path: '/business/kehu_detail/yewu_luntan',
					name: 'yewu_luntan',
					component: yewu_luntan => require([
						'@/components/business/kehu_detail/yewu_luntan.vue'
					], yewu_luntan),
					meta: [{
						url: '',
						name: '业务论坛'
					}]
				},
				// -----------------------这里开始------------------------
				{
					path: '/business/kehu_detail/kaifa_guanli',
					name: 'kaifa_guanli',
					component: kaifa_guanli => require([
						'@/components/business/kehu_detail/kaifa_guanli.vue'
					], kaifa_guanli),
					meta: [{
						url: '',
						name: '开发管理'
					}]
				}, {
					path: '/business/kehu_detail/qiye_addressBook',
					name: 'qiye_addressBook',
					component: qiye_addressBook => require([
							'@/components/business/kehu_detail/qiye_addressBook.vue'
						],
						qiye_addressBook),
					meta: [{
						url: '',
						name: '通讯录'
					}]
				}, {
					path: '/business/kehu_detail/falv_fuwu',
					name: 'falv_fuwu',
					component: falv_fuwu => require(['@/components/business/kehu_detail/falv_fuwu.vue'],
						falv_fuwu),
					meta: [{
						url: '',
						name: '法律服务'
					}]
				}, {
					path: '/business/kehu_detail/fuwu_hetong',
					name: 'fuwu_hetong',
					component: fuwu_hetong => require([
						'@/components/business/kehu_detail/fuwu_hetong.vue'
					], fuwu_hetong),
					meta: [{
						url: '',
						name: '服务合同'
					}]
				}, {
					path: '/business/kehu_detail/caiwu_guanli_index',
					name: 'caiwu_guanli_index',
					component: caiwu_guanli_index => require([
							'@/components/business/kehu_detail/caiwu_guanli_index.vue'
						],
						caiwu_guanli_index),
					meta: [{
						url: '',
						name: '财务管理'
					}],

					redirect: {
						name: 'shangwu_baobiao'
					},


					children: [{
							path: '/business/kehu_detail/shangwu_baobiao',
							name: 'shangwu_baobiao',
							component: shangwu_baobiao => require([
									'@/components/business/kehu_detail/shangwu_baobiao.vue'
								],
								shangwu_baobiao),
							meta: [{
								url: '',
								name: '商务报表'
							}]
						},
						{
							path: '/business/kehu_detail/wanglai_pingzheng',
							name: 'wanglai_pingzheng',
							component: wanglai_pingzheng => require([
								'@/components/business/kehu_detail/wanglai_pingzheng.vue'
							], wanglai_pingzheng),
							meta: [{
								url: '',
								name: '往来凭证'
							}]
						}, {
							path: '/business/kehu_detail/kaipiao_jilu',
							name: 'kaipiao_jilu_business',
							component: kaipiao_jilu => require([
									'@/components/business/kehu_detail/kaipiao_jilu.vue'
								],
								kaipiao_jilu),
							meta: [{
								url: '',
								name: '开票记录'
							}]
						},
						{
							path: '/business/kehu_detail/caiwu_zhanghao',
							name: 'caiwu_zhanghao_business',
							component: caiwu_zhanghao => require([
									'@/components/business/kehu_detail/caiwu_zhanghao.vue'
								],
								caiwu_zhanghao),
							meta: [{
								url: '',
								name: '财务账号'
							}]
						}
					]
				}, {
					path: '/business/kehu_detail/ticheng_jilu',
					name: 'ticheng_jilu',
					component: ticheng_jilu => require([
						'@/components/business/kehu_detail/ticheng_jilu.vue'
					], ticheng_jilu),
					meta: [{
						url: '',
						name: '提成记录'
					}]
				}, {
					path: '/business/kehu_detail/xiaoshou_yuce',
					name: 'xiaoshou_yuce',
					component: xiaoshou_yuce => require([
						'@/components/business/kehu_detail/xiaoshou_yuce.vue'
					], xiaoshou_yuce),
					meta: [{
						url: '',
						name: '销售预测'
					}]
				}, {
					path: '/business/kehu_detail/falv_fengxian_ku',
					name: 'falv_fengxian_ku',
					component: falv_fengxian_ku => require([
							'@/components/business/kehu_detail/falv_fengxian_ku.vue'
						],
						falv_fengxian_ku),
					meta: [{
						url: '',
						name: '建科法律风险数据库'
					}]
				}, {
					path: '/business/kehu_detail/falv_fengxian_ku_company',
					name: 'falv_fengxian_ku_company',
					component: falv_fengxian_ku_company => require([
							'@/components/business/kehu_detail/falv_fengxian_ku_company.vue'
						],
						falv_fengxian_ku_company),
					meta: [{
						url: '',
						name: '企业法律风险数据库'
					}]
				}, {
					path: '/business/kehu_detail/falv_wenda_ku',
					name: 'falv_wenda_ku',
					component: falv_wenda_ku => require([
						'@/components/business/kehu_detail/falv_wenda_ku.vue'
					], falv_wenda_ku),
					meta: [{
						url: '',
						name: '建科法律问答库'
					}]
				}, {
					path: '/business/kehu_detail/falv_moban_ku',
					name: 'falv_moban_ku',
					component: falv_moban_ku => require([
						'@/components/business/kehu_detail/falv_moban_ku.vue'
					], falv_moban_ku),
					meta: [{
						url: '',
						name: '建科法律模板库'
					}]
				}, {
					path: '/business/kehu_detail/falv_wenzhai_ku',
					name: 'falv_wenzhai_ku',
					component: falv_wenzhai_ku => require([
							'@/components/business/kehu_detail/falv_wenzhai_ku.vue'
						],
						falv_wenzhai_ku),
					meta: [{
						url: '',
						name: '建科法律文摘库'
					}]
				}
			],
		},

		// 上面是商务管理
		{
			// 律师详情页
			path: '/legal_data/lawyer_detail',
			name: 'lawyer_detail',
			component: lawyer_detail => require(['@/components/legal_data/lawyer_detail.vue'],
				lawyer_detail),
			meta: {
				url: '',
				name: "律师详情"
			}
		},
		{
			path: '/legal/legal_hetong/historyEdition',
			name: 'historyEdition',
			component: historyEdition => require(['@/components/legal/legal_hetong/historyEdition.vue'],
				historyEdition),
			meta: [{
				url: '',
				name: '历史评估'
			}],
		},

		{
			// 法务管理中风险评估等 页面跳转
			path: '/legal/service_detail/service_detail_index',
			name: 'service_detail_index',

			component: service_detail_index => require([
					'@/components/legal/service_detail/service_detail_index.vue'
				],
				service_detail_index),

			children: [{
				// 风险评估详情
				path: '/legal/service_detail/risk_pinggu_detail',
				name: 'risk_pinggu_detail',
				component: risk_pinggu_detail => require([
						'@/components/legal/service_detail/risk_pinggu_detail.vue'
					],
					risk_pinggu_detail),
			}, {
				// 法律培训详情
				path: '/legal/service_detail/legal_peixun_detail',
				name: 'legal_peixun_detail',
				component: legal_peixun_detail => require([
						'@/components/legal/service_detail/legal_peixun_detail.vue'
					],
					legal_peixun_detail),
			}, {
				// 法律咨询详情
				path: '/legal/service_detail/legal_zixun_detail',
				name: 'legal_zixun_detail',
				component: legal_zixun_detail => require([
						'@/components/legal/service_detail/legal_zixun_detail.vue'
					],
					legal_zixun_detail),
			}, {
				// 综合法务详情
				path: '/legal/service_detail/zonghe_fawu_detail',
				name: 'zonghe_fawu_detail',
				component: zonghe_fawu_detail => require([
						'@/components/legal/service_detail/zonghe_fawu_detail.vue'
					],
					zonghe_fawu_detail),
			}, {
				// 合同法务详情
				path: '/legal/service_detail/hetong_fawu_detail',
				name: 'hetong_fawu_detail',
				component: hetong_fawu_detail => require([
						'@/components/legal/service_detail/hetong_fawu_detail.vue'
					],
					hetong_fawu_detail),
			}, {
				// 项目法务详情
				path: '/legal/service_detail/xiangmu_fawu_detail',
				name: 'xiangmu_fawu_detail',
				component: xiangmu_fawu_detail => require([
						'@/components/legal/service_detail/xiangmu_fawu_detail.vue'
					],
					xiangmu_fawu_detail),
			}, {
				// 其他评估详情
				path: '/legal/service_detail/other_detail',
				name: 'other_detail',
				component: other_detail => require([
						'@/components/legal/service_detail/other_detail.vue'
					],
					other_detail),
			}, ]
		},



		{
			// [法律数据] 风险详情页
			path: '/legal_data/detail/risk_detail',
			name: 'risk_detail',
			component: risk_detail => require(['@/components/legal_data/detail/risk_detail.vue'],
				risk_detail),
			meta: {
				url: '',
				name: "风险详情",
				requireAuth: false
			},
		},

		{
			// [法律数据] 法律问答详情页
			path: '/legal_data/detail/answer_detail',
			name: 'answer_detail',
			component: answer_detail => require(['@/components/legal_data/detail/answer_detail.vue'],
				answer_detail),
			meta: {
				url: '',
				name: "问答详情",
				requireAuth: false
			},
		},
		{
			// [法律数据] 法律问答详情页
			path: '/legal_data/detail/answer_detail_web',
			name: 'answer_detail_web',
			component: answer_detail_web => require(['@/components/legal_data/detail/answer_detail_web.vue'],
				answer_detail_web),
			meta: {
				url: '',
				name: "问答详情",
				requireAuth: false
			},
		},
		
		

		{
			// [法律数据] 法律问答详情页
			path: '/legal_data/detail/law_answer_detail',
			name: 'law_answer_detail',
			component: law_answer_detail => require([
				'@/components/legal_data/detail/law_answer_detail.vue'], law_answer_detail),
			meta: {
				url: '',
				name: "问答详情",
				requireAuth: false
			},
		},
		{
			// [法律数据] 法律问答详情页
			path: '/legal_data/detail/law_answer_detail2',
			name: 'law_answer_detail2',
			component: law_answer_detail2 => require([
				'@/components/legal_data/detail/law_answer_detail2.vue'], law_answer_detail2),
			meta: {
				url: '',
				name: "问答详情",
				requireAuth: false
			},
		},
		{
			// [法律数据] 法律问答详情页
			path: '/legal_data/detail/law_answer_detail_custom',
			name: 'law_answer_detail_custom',
			component: law_answer_detail_custom => require([
				'@/components/legal_data/detail/law_answer_detail_custom.vue'
			], law_answer_detail_custom),
			meta: {
				url: '',
				name: "问答详情",
				requireAuth: false
			},
		},
		{
			// [法律数据] 法律问答详情页
			path: '/legal_data/detail/law_logical_tool_detail',
			name: 'law_logical_tool_detail',
			component: law_logical_tool_detail => require([
				'@/components/legal_data/detail/law_logical_tool_detail.vue'
			], law_logical_tool_detail),
			meta: {
				url: '',
				name: "逻辑详情",
				requireAuth: false
			},
		},

		{
			// [案件梳理] 法律文件详情页
			path: '/legal_data/detail/law_file_detail',
			name: 'law_file_detail',
			component: law_file_detail => require(['@/components/legal_data/detail/law_file_detail.vue'],
				law_file_detail),
			meta: {
				url: '',
				name: "法律文件详情",
				requireAuth: false
			},
		},

		{
			// [案件梳理] 法律文件详情页
			path: '/legal_data/detail/law_file_detail_custom',
			name: 'law_file_detail_custom',
			component: law_file_detail_custom => require([
				'@/components/legal_data/detail/law_file_detail_custom.vue'
			], law_file_detail_custom),
			meta: {
				url: '',
				name: "法律文件详情",
				requireAuth: false
			},
		},

		{
			// [法律数据] 法律问答详情页
			path: '/zx',
			name: 'zx',
			component: zx => require(['@/components/legal_data/detail/zixun_detail.vue'], zx),
			meta: {
				url: '',
				name: "咨询详情",
				requireAuth: false
			},
		},
		
		{
			path: '/overall/teamwork/lawyerInfo',
			name: 'lawyerInfo',
			component: lawyerInfo => require(['@/components/overall/teamwork/lawyerInfo.vue'], lawyerInfo),
			meta: {
				url: '',
				name: '律师详情'
			}
		},
		{
			// [法律数据] 法律文摘详情页
			path: '/legal_data/detail/article_detail',
			name: 'article_detail',
			component: article_detail => require(['@/components/legal_data/detail/article_detail.vue'],
				article_detail),
			meta: {
				url: '',
				name: "文摘详情",
				requireAuth: false
			},
		},

		{
			// [法律数据] 法律模板详情页
			path: '/legal_data/detail/moban_detail',
			name: 'moban_detail',
			component: moban_detail => require(['@/components/legal_data/detail/moban_detail.vue'],
				moban_detail),
			meta: {
				url: '',
				name: "模板",
				requireAuth: false
			},
		},





		/** 员工信息 */
		{
			path: '/page',
			name: 'page',
			component: () =>
				import('@/view/main/baseinfo/baseinfo.vue'),
			redirect: {
				name: 'basePage'
			},

			children: [{
					path: '/page/employee/home',
					name: 'employeeHome',
					component: employeeHome => require(['@/components/personnel/employee/home.vue'],
						employeeHome),
					meta: [{
						url: '',
						name: '人事管理'
					}, {
						url: '',
						name: '主页'
					}]
				},
				{
					path: '/page/employee/person_record',
					name: 'personRecord',
					component: personRecord => require([
						'@/components/personnel/employee/person_record.vue'
					], personRecord),
					meta: [{
						url: '',
						name: '人事管理'
					}, {
						url: '',
						name: '人事记录'
					}]
				},
				{
					path: '/page/employee/detail',
					name: 'employeeInfo',
					component: employeeInfo => require(['@/components/personnel/employee/detail.vue'],
						employeeInfo),
					meta: [{
						url: '',
						name: '人事管理'
					}, {
						url: '',
						name: '基本信息'
					}]
				},
				{
					path: '/page/employee/entryFrom',
					name: 'entryFrom',
					component: entryFrom => require(['@/components/personnel/employee/entryFrom.vue'],
						entryFrom),
					meta: [{
						url: '',
						name: '人事管理'
					}, {
						url: '',
						name: '入职信息表'
					}]
				},
				{
					path: '/page/employee/regularizationFrom',
					name: 'regularizationFrom',
					component: regularizationFrom => require(['@/components/personnel/employee/regularizationFrom.vue'],
						regularizationFrom),
					meta: [{
						url: '',
						name: '人事管理'
					}, {
						url: '',
						name: '转正申请表'
					}]
				},
				{
					path: '/page/employee/person_report',
					name: 'person_report',
					component: person_report => require(['@/components/personnel/employee/person_report.vue'],
						person_report),
					meta: [{
						url: '',
						name: '人事管理'
					}, {
						url: '',
						name: '个人报表'
					}]
				},
				
				
				
				
				{
					path: '/page/employee/planSummaryPersonList',
					name: 'planSummaryPersonList',
					component: planSummaryPersonList => require(['@/components/personnel/employee/planSummaryPersonList.vue'],
						planSummaryPersonList),
					meta: [{
						url: '',
						name: '人事管理'
					}, {
						url: '',
						name: '计划总结'
					}]
				},
				{
					path: '/page/employee/planSummaryStudyList',
					name: 'planSummaryStudyList',
					component: planSummaryStudyList => require(['@/components/personnel/employee/planSummaryStudyList.vue'],
						planSummaryStudyList),
					meta: [{
						url: '',
						name: '人事管理'
					}, {
						url: '',
						name: '学习计划总结'
					}]
				},
				{
					path: '/page/employee/planSummaryInternshipList',
					name: 'planSummaryInternshipList',
					component: planSummaryInternshipList => require(['@/components/personnel/employee/planSummaryInternshipList.vue'],
						planSummaryInternshipList),
					meta: [{
						url: '',
						name: '人事管理'
					}, {
						url: '',
						name: '实习计划总结'
					}]
				},
				{
					path: '/page/employee/labor',
					name: 'employeeLabor',
					component: employeeLabor => require(['@/components/personnel/employee/labor.vue'],
						employeeLabor),
					meta: [{
						url: '',
						name: '人事管理'
					}, {
						url: '',
						name: '劳资管理'
					}]
				},
				{
					path: '/page/employee/evaluation',
					name: 'employeeEvaluation',
					component: employeeEvalute => require([
						'@/components/personnel/employee/evaluation.vue'
					], employeeEvalute),
					meta: [{
						url: '',
						name: '人事管理'
					}, {
						url: '',
						name: '个人评价'
					}]
				},
				{
					path: '/page/employee/jobduty',
					name: 'jobDuty',
					component: jobDuty => require(['@/components/personnel/employee/duty.vue'],
						jobDuty),
					meta: [{
						url: '',
						name: '人事管理'
					}, {
						url: '',
						name: '工作职责'
					}]
				},
				{
					path: '/page/employee/propaganda',
					name: 'propaganda',
					component: propaganda => require(['@/components/personnel/employee/propaganda.vue'],
						propaganda),
					meta: [{
						url: '',
						name: '人事管理'
					}, {
						url: '',
						name: '宣传信息'
					}]
				},

				{
					path: '/page/employee/traininfo',
					name: 'trainInfo',
					component: trainInfo => require(['@/components/personnel/employee/traininfo.vue'],
						trainInfo),
					meta: [{
						url: '',
						name: '人事管理'
					}, {
						url: '',
						name: '培训信息'
					}]
				},
			]
		},

		/** 培训课程 */
		{
			path: '/trainCourse',
			name: 'trainCourse',
			component: () =>
				import('@/view/main/traincourse/baseinfo.vue'),
			redirect: {
				name: 'coursePage'
			},

			children: [{
					path: '/trainCourse/outline',
					name: 'trainOutline',
					component: trainOutline => require([
							'@/components/personnel/employee/trainCourse/trainOutline.vue'
						],
						trainOutline),
					meta: [{
						url: '',
						name: '人事管理'
					}, {
						url: '',
						name: '培训纲要'
					}]
				},
				{
					path: '/trainCourse/evaluation',
					name: 'trainEvaluate',
					component: trainEvaluate => require([
							'@/components/personnel/employee/trainCourse/trainEvaluate.vue'
						],
						trainEvaluate),
					meta: [{
						url: '',
						name: '培训课程'
					}, {
						url: '',
						name: '学员评价'
					}]
				},


			]
		},
		{
			path: '/business/map',
			name: 'map',
			component: map => require(['@/components/business/map.vue'],
				map),
			meta: [{
				url: '',
				name: '地图'
			}]
		},

		{
			path: '/business/myMap',
			name: 'myMap',
			component: myMap => require(['@/components/business/myMap.vue'],
				myMap),
			meta: [{
				url: '',
				name: '地图'
			}]
		},

		{
			// 注册页
			path: '/login',
			name: 'login',
			component: () =>
				import('@/view/main/login'),
			meta: {
				title: "建科律师法务平台 - 登录",
				url: '',
				index: "1"
			}
		},
		{
			// 注册页
			path: '/login/custom',
			name: 'login_custom',
			component: () =>
				import('@/view/main/login_custom'),
			meta: {
				title: "建科律师法务平台 - 登录",
				url: '',
				index: "1"
			}
		},
		{
			// 404页面
			path: '*',
			component: () =>
				import('@/view/main/notfind'),
		},
		{
			// 测试地图
			path: '/business/test',
			name: 'test',
			component: () =>
				import('@/components/business/test.vue'),
		},

		{
			path: '/overall/commonQA/edit',
			name: 'commonQAEdit',
			component: commonQAEdit => require(['@/components/overall/commonQA/edit'], commonQAEdit),
			meta: {
				breadList: [{
					url: '',
					name: '综合管理'
				}, {
					url: 'commonQAEdit',
					name: '编辑常见问答'
				}]
			}
		},

		{
			// 新加的制度指南详情
			path: '/overall/systemGuide/new_detail',
			name: 'new_detail',
			component: new_detail => require(['@/components/overall/systemGuide/new_detail'], new_detail),
		},


		//新加的计划管理  综合总结  新窗口跳转
		{
			path: '/planSummary/new_planSummaryEdit',
			name: 'new_planSummaryEdit',
			component: new_planSummaryEdit => require([
					'@/components/overall/planSummary/new_planSummaryEdit'
				],
				new_planSummaryEdit),
			meta: {
				breadList: [{
					url: '',
					name: '综合管理'
				}, {
					url: '',
				}]
			}
		},
		//新版本计划总结2
		{
			path: '/planSummary/new_planSummaryEdit2',
			name: 'new_planSummaryEdit2',
			component: new_planSummaryEdit2 => require([
					'@/components/overall/planSummary/new_planSummaryEdit2'
				],
				new_planSummaryEdit2),
			meta: {
				breadList: [{
					url: '',
					name: '综合管理'
				}, {
					url: '',
				}]
			}
		},
		//新版本计划总结3
		{
			path: '/planSummary/new_planSummaryEdit3',
			name: 'new_planSummaryEdit3',
			component: new_planSummaryEdit3 => require([
					'@/components/overall/planSummary/new_planSummaryEdit3'
				],
				new_planSummaryEdit3),
			meta: {
				breadList: [{
					url: '',
					name: '综合管理'
				}, {
					url: '',
				}]
			}
		},

		//新版本计划总结
		{
			path: '/planSummary/work_task_detail',
			name: 'work_task_detail',
			component: work_task_detail => require(['@/components/overall/planSummary/work_task_detail'],
				work_task_detail),
			meta: {
				breadList: [{
					url: '',
					name: '综合管理'
				}, {
					url: '',
				}]
			}
		},
		{
			path: '/overall/commonQA/new_commonQA_detail',
			name: 'new_commonQA_detail',
			component: new_commonQA_detail => require(['@/components/overall/commonQA/new_commonQA_detail'],
				new_commonQA_detail),
			meta: {
				breadList: [{
					url: '',
					name: '综合管理'
				}, {
					url: '',
					name: '常见问答'
				}]
			}
		},

		{
			path: '/innerForum/detail',
			name: 'innerForumDetail',
			component: innerForumDetail => require(['@/components/overall/innerForum/detail'],
				innerForumDetail),
			meta: [{
				url: '',
				name: '综合管理'
			}, {
				url: '',
				name: '内部论坛详情'
			}]
		},
		{
			path: '/finance_report/shangwu_detail',
			name: 'shangwuDetail',
			component: shangwuDetail => require(['@/components/finance/finance_report/shangwu_detail.vue'],
				shangwuDetail),
			meta: [{
				url: '',
				name: '商务报表详情'
			}]
		},
		{
			path: '/personnel/employee/salaryConfirm',
			name: 'salaryConfirm',
			component: salaryConfirm => require(['@/components/personnel/employee/salaryConfirm.vue'],
				salaryConfirm),
			meta: [{
				url: '',
				name: '人事管理'
			}, {
				url: '',
				name: '薪资确认'
			}]
		},
		{
			path: '/finance/xinzi_fafang',
			name: 'xinzi_fafang',
			component: xinzi_fafang => require(["@/components/finance/xinzi_fafang.vue"], xinzi_fafang),
			meta: [{
				url: '',
				name: '财务管理'
			}, {
				url: '',
				name: '薪资发放'
			}]
		},
		{
			path: '/finance/xinzi_tongji',
			name: 'xinzi_tongji',
			component: xinzi_tongji => require(["@/components/finance/xinzi_tongji.vue"], xinzi_tongji),
			meta: [{
				url: '',
				name: '财务管理'
			}, {
				url: '',
				name: '薪资统计'
			}]
		},
		// 下面是财务管理
		{
			path: '/finance/finance_report/index_report',
			name: 'index_report',
			component: index_report => require(['@/components/finance/finance_report/index_report.vue'],
				index_report),
			meta: [{
				url: '',
				name: '财务管理'
			}, {
				url: '',
				name: '财务报表'
			}],

			redirect: {
				name: "shangwu_report"
			},
			children: [{
					path: '/finance/finance_report/shangwu_report',
					name: 'shangwu_report',
					component: shangwu_report => require([
							'@/components/finance/finance_report/shangwu_report.vue'
						],
						shangwu_report),
					meta: [{
						url: '',
						name: '财务管理'
					}, {
						url: '',
						name: '商务报表'
					}],
				},
				{
					path: '/finance/finance_report/guanli_report',
					name: 'guanli_report',
					component: guanli_report => require([
							'@/components/finance/finance_report/guanli_report.vue'
						],
						guanli_report),
					meta: [{
						url: '',
						name: '财务管理'
					}, {
						url: '',
						name: '管理报表'
					}],
				}, {
					path: '/finance/finance_report/HR_report',
					name: 'HR_report',
					component: HR_report => require([
						'@/components/finance/finance_report/HR_report.vue'], HR_report),
					meta: [{
						url: '',
						name: '财务管理'
					}, {
						url: '',
						name: 'HR报表'
					}],
				},
			]
		},
		{
			path: '/finance_report/pingzheng_detail',
			name: 'pingzhengDetail',
			component: pingzhengDetail => require([
					'@/components/finance/finance_report/pingzheng_detail.vue'
				],
				pingzhengDetail),
			meta: [{
				url: '',
				name: '管理报表详情'
			}]
		},
		{
			path: '/components/finance/finance_report/rangking',
			name: 'rangking',
			component: rangking => require(['@/components/finance/finance_report/rangking.vue'],
				rangking),
			meta: [{
				url: '',
				name: '管理报表详情'
			}]
		},
		{
			// 生成打印
			path: '/public/generatePrint',
			name: 'generatePrint',
			component: generatePrint => require(['@/components/public/generatePrint.vue'], generatePrint),
			meta: {
				breadList: [{
					url: '',
					name: '生成打印'
				}]
			}
		},
		{
			// deepseek
			path: '/public/deepSeekChatDialog',
			name: 'deepSeekChatDialog',
			component: deepSeekChatDialog => require(['@/components/public/deepSeekChatDialog.vue'], deepSeekChatDialog),
			meta: {
				breadList: [{
					url: '',
					name: 'deepseek'
				}]
			}
		},
		{
			// deepseek
			path: '/public/deepSeekChatHome',
			name: 'deepSeekChatHome',
			component: deepSeekChatHome => require(['@/components/public/deepSeekChatHome.vue'], deepSeekChatHome),
			meta: {
				breadList: [{
					url: '',
					name: 'deepseek'
				}]
			}
		},
		{
			// 生成打印
			path: '/public/contractProcessPrint',
			name: 'contractProcessPrint',
			component: contractProcessPrint => require(['@/components/public/contractProcessPrint.vue'], contractProcessPrint),
			meta: {
				breadList: [{
					url: '',
					name: '生成打印'
				}]
			}
		},
		{
			// 生成打印
			path: '/public/projectPrint',
			name: 'projectPrint',
			component: projectPrint => require(['@/components/public/projectPrint.vue'], projectPrint),
			meta: {
				breadList: [{
					url: '',
					name: '生成打印'
				}]
			}
		},
		{
			// 生成打印
			path: '/public/businessProcessPrint',
			name: 'businessProcessPrint',
			component: businessProcessPrint => require(['@/components/public/businessProcessPrint.vue'], businessProcessPrint),
			meta: {
				breadList: [{
					url: '',
					name: '生成打印'
				}]
			}
		},
		{
			// case生成打印
			path: '/public/casePrint',
			name: 'casePrint',
			component: casePrint => require(['@/components/public/casePrint.vue'], casePrint),
			meta: {
				breadList: [{
					url: '',
					name: '生成打印'
				}]
			}
		},
		{
			// case生成打印
			path: '/public/advisePrint',
			name: 'advisePrint',
			component: advisePrint => require(['@/components/public/advisePrint.vue'], advisePrint),
			meta: {
				breadList: [{
					url: '',
					name: '生成打印'
				}]
			}
		},
		{
			// case生成打印
			path: '/public/legal_logical_tool_print',
			name: 'legal_logical_tool_print',
			component: legal_logical_tool_print => require([
				'@/components/public/legal_logical_tool_print.vue'
			], legal_logical_tool_print),
			meta: {
				breadList: [{
					url: '',
					name: '生成打印'
				}]
			}
		},
		
		{
			// case生成打印
			path: '/public/legal_logical_sorting_print',
			name: 'legal_logical_sorting_print',
			component: legal_logical_sorting_print => require([
				'@/components/public/legal_logical_sorting_print.vue'
			], legal_logical_sorting_print),
			meta: {
				breadList: [{
					url: '',
					name: '生成打印'
				}]
			}
		},

		{
			// case生成打印
			path: '/public/caseRecordPrint',
			name: 'caseRecordPrint',
			component: caseRecordPrint => require(['@/components/public/case_service_record_print.vue'],
				caseRecordPrint),
			meta: {
				breadList: [{
					url: '',
					name: '生成打印'
				}]
			}
		},



		{
			// case生成打印
			path: '/public/caseEvidencePrint',
			name: 'caseEvidencePrint',
			component: caseEvidencePrint => require(['@/components/public/caseEvidencePrint.vue'],
				caseEvidencePrint),
			meta: {
				breadList: [{
					url: '',
					name: '生成打印'
				}]
			}
		},
		{
			path: '/app/question/detail',
			name: 'app_question_details',
			component: app_question_details => require(['@/components/app/app_question_details.vue'],
				app_question_details),
			meta: {
				breadList: [{
					url: '',
					name: '问答详情'
				}]
			}
		},
		{
			path: '/legal_data/legal_risk2',
			name: 'legal_risk2',
			component: legal_risk2 => require(['@/components/legal_data/legal_risk2.vue'],
				legal_risk2),
			meta: [{
				url: '',
				name: '法律数据'
			}, {
				url: '',
				name: '法律风险数据库'
			}],
		
		},
		{
			path: '/invite',
			name: 'app_question_detail',
			component: app_question_detail => require([
					'@/components/legal_data/detail/app_question_detail.vue'
				],
				app_question_detail),
			meta: {
				breadList: [{
					url: '',
					name: '问答详情'
				}]
			}
		},
		{
			path: '/protocol',
			name: 'app_protocol',
			component: app_protocol => require(['@/components/legal_data/detail/app_protocol.vue'],
				app_protocol),

			meta: {
				breadList: [{
					url: '',
					name: 'app界面'
				}, {
					url: 'app_protocol',
					name: '列表'
				}]
			}
		},

		{
			path: '/overall/notice/new_notice_detail',
			name: 'new_notice_detail',
			component: new_notice_detail => require(['@/components/overall/notice/new_notice_detail'],
				new_notice_detail),
			meta: {
				breadList: [{
					url: '',
					name: '通知公告'
				}, {
					url: '',
					name: '详情'
				}]
			}
		},

		{
			path: '/innerData/new_innerDataDetail',
			name: 'new_innerDataDetail',
			component: new_innerDataDetail => require([
				'@/components/overall/innerData/new_innerDataDetail'],
				new_innerDataDetail),
			meta: {
				breadList: [{
					url: '',
					name: '综合管理'
				}, {
					url: '',
					name: '内部资料详情'
				}]
			}
		},

		// 员工通讯录详情
		{
			path: '/contact/employee/detail',
			name: 'employeeContactDetail',
			component: employeeContactDetail => require(['@/components/telephone/employeeDetail'],
				employeeContactDetail),
			meta: [{
				url: '',
				name: '通讯录'
			}, {
				url: '',
				name: '员工通讯录'
			}]
		},

		// 客户通讯录详情
		{
			path: '/contact/customer/detail',
			name: 'customerContactDetail',
			component: customerContactDetail => require(['@/components/telephone/customerDetail'],
				customerContactDetail),
			meta: [{
				url: '',
				name: '通讯录'
			}, {
				url: '',
				name: '客户通讯录'
			}]
		},

		{
			path: '/custom/kehu_falv_shiwu',
			name: 'kehu_falv_shiwu',
			component: kehu_falv_shiwu => require(['@/components/custom/kehu_falv_shiwu.vue'],
				kehu_falv_shiwu),
		},

	]
})

// router.beforeEach(function(to, from, next) {
// 	if (!localStorage.getItem('loginInfo')) {
// 		console.log(localStorage.getItem('loginInfo'))
// 		console.log(!localStorage.getItem('loginInfo'))
// 		if (to.path !== '/login') {
// 			return next('/login')
// 		}
// 	}
// 	// document.title = to.meta.title
// 	next()
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js